import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaff2c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-cascader base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cascader = _resolveComponent("Cascader")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["inner", { placeholder: _ctx.modelValue.length == 0, disabled: _ctx.disabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPopup && _ctx.showPopup(...args)))
    }, _toDisplayString(_ctx.selectText || _ctx.placeholder), 3),
    _createVNode(_component_Popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Cascader, {
          modelValue: _ctx.cascaderValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cascaderValue) = $event)),
          title: "请选择所在地区",
          options: _ctx.options,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = false)),
          onFinish: _ctx.onFinish,
          onChange: _ctx.onChange
        }, null, 8, ["modelValue", "options", "onFinish", "onChange"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}